import { IntegrityMonitorRulesSmartViewsWebComponent } from '../component/IntegrityMonitorRulesSmartViewsWebComponent';
import { templateIntegrityMonitorRulesSmartViews } from '../view/template';
import { IntegrityMonitorRulesSmartViewsView } from '../view/IntegrityMonitorRulesSmartViewsView';
import { GridSmartViewsController } from '../../../../grid/gridSmartViews/controller/GridSmartViewsController';
import { GridSmartViewsWebComponentSchema } from '../../../../grid/gridSmartViews/types';
import { Column, Filter } from '../../integrityMonitorRulesGrid/types';
import { ViewType } from '../types';
import { IntegrityMonitorEventsRepository } from '../repository/IntegrityMonitorRulesSmartViewsRepository';

export class IntegrityMonitorRulesSmartViewsController extends GridSmartViewsController<Column, Filter, ViewType> {
  public component: IntegrityMonitorRulesSmartViewsWebComponent;
  public view: IntegrityMonitorRulesSmartViewsView;
  public viewConstructor: typeof IntegrityMonitorRulesSmartViewsView;
  public dataRepository: IntegrityMonitorEventsRepository;
  public dataRepositoryConstructor: typeof IntegrityMonitorEventsRepository;

  constructor(component: IntegrityMonitorRulesSmartViewsWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IntegrityMonitorRulesSmartViewsView,
      dataRepositoryConstructor: IntegrityMonitorEventsRepository,
      viewTemplate: templateIntegrityMonitorRulesSmartViews,
    });
  }

  async getDataForView(): Promise<GridSmartViewsWebComponentSchema<Column, Filter, ViewType>> {
    const { ruleSetIdentifiers, activeViewId } = await this.dataRepository.getDataForView();

    this.component.ruleSetIdentifiers = ruleSetIdentifiers;
    this.component.activeViewId = this.component.activeViewId ?? activeViewId;

    this.component.sections = [
      this.view.getRulesSection(this.component.activeViewId),
      this.view.getRuleSetsSection(this.component.ruleSetIdentifiers, this.component.activeViewId),
    ];

    return {
      sections: this.component.sections,
      activeViewId: this.component.activeViewId,
    };
  }
}
